import AppComponent from '../common/components/AppComponent';
import AppCommonConstants from '../common/constants/AppCommonConstants';
import AppBootstrap from './AppBootstrap';

AppCommonConstants.setup();

const app = new AppBootstrap();

app.run(AppComponent);
